<template>

</template>

<script>
import CONST from "@/utils/Constants";
import GAMixins from "../mixins/GAMixins";

export default {
  name: "OrderConfirmationComponent",
  data() {
    return {
      data: null,
      json: null,
      totals: null,
    }
  },
  mixins: [
    GAMixins
  ],
  methods: {
    printOrderConfirmation(order) {
      ACC.log.group("printOrderConfirmation " + order.code)
      ACC.log.info({'order': order})
      let revenue = order.totalPrice.value ? order.totalPrice.value : 0;
      let taxes = this.getTotalTaxFromCart(order);
      let shipping = this.getDeliveryCostFromCart(order);

      const entry = {
        event: "purchase",
        ecommerce: {
          currency: ACC.config.user.currency.isocode,
          transaction_id: order.code,
          shipping: shipping,
          tax: taxes,
          value: revenue,
          commercial_organization: this.getCommercialOrganization(),
          items: this.getProductEntries(order.entries),
        }
      }
      this.pushEvent(entry);
      console.groupEnd();
    },
  },
  created() {

    GoogleAnalyticsEventBus.$on(CONST.EVENT.GOOGLE.ORDER_CONFIRMATION, ({order}) => {
      this.data = order;
      this.printOrderConfirmation(order);
      for (const preOrder in order.relatedOrders) {
        this.printOrderConfirmation(order.relatedOrders[preOrder])
      }
    });
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/global/lptGoogleAnalytics/components/OrderConfirmationComponent.vue